import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { AppState } from '../../../../../types/store';
import { Props } from './ShopPrints';
import { createOrOpenChatWithUser } from '@wix/da-shared-react/pkg/Chat/redux/actions';
import { PapiUser } from '@wix/da-papi-types';

type DispatchProps = Pick<Props, 'onOpenChat'>;
type StateProps = Pick<Props, 'isOwner'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  return {
    isOwner: isCurrentUserProfileOwner(state),
    user: getProfileOwnerUser(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  onOpenChat: (user: PapiUser) => {
    dispatch(
      createOrOpenChatWithUser(`shop-empty-state-${user.useridUuid}`, user)
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
